import { useState, useEffect } from "react";

const THEME_STORAGE_KEY = "panda_data_table_theme";

export const useTheme = () => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Initialize from localStorage synchronously to avoid flash
    try {
      const savedTheme = localStorage.getItem(THEME_STORAGE_KEY);
      if (savedTheme !== null) {
        return JSON.parse(savedTheme);
      }
    } catch (err) {
      console.error("Error loading saved theme:", err);
    }
    return true; // Default to dark mode
  });

  // Save theme preference to localStorage whenever it changes
  useEffect(() => {
    try {
      localStorage.setItem(THEME_STORAGE_KEY, JSON.stringify(isDarkMode));
    } catch (err) {
      console.error("Error saving theme preference:", err);
    }
  }, [isDarkMode]);

  // Toggle theme function
  const toggleTheme = () => {
    setIsDarkMode((prev) => !prev);
  };

  return { isDarkMode, toggleTheme };
};
